import { useTranslator } from '@/i18n'
import { isValidDate } from '@/utils/date'

export type DateFormatter = (
    date: string | Date,
    options?: Intl.DateTimeFormatOptions
) => string

export function useDateFormat(
    defaultOptions: Intl.DateTimeFormatOptions = {
        month: 'long',
        day: 'numeric',
    }
): DateFormatter {
    const { locale } = useTranslator()

    return (
        date: string | Date,
        options: Intl.DateTimeFormatOptions = defaultOptions
    ): string => {
        if (!date) {
            return ''
        }

        const dateObj = new Date(date)

        if (!isValidDate(dateObj)) {
            return ''
        }

        if (dateObj.getFullYear() !== new Date().getFullYear()) {
            options.year = 'numeric'
        }

        return dateObj.toLocaleDateString(locale.value, options)
    }
}

export type TimeFormatter = (
    date: string | Date,
    options?: Intl.DateTimeFormatOptions
) => string

export function useTimeFormat(
    defaultOptions: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
    }
): TimeFormatter {
    const { locale } = useTranslator()

    return (
        date: string | Date,
        options: Intl.DateTimeFormatOptions = defaultOptions
    ): string => {
        if (!date) {
            return ''
        }

        const dateObj = new Date(date)

        if (!isValidDate(dateObj)) {
            return ''
        }

        return dateObj.toLocaleTimeString(locale.value, options)
    }
}
